import {  createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingStatus: false,
  searchedParameter: "",
  memberList: {},
};


export const MemberSlice = createSlice({
    name: "MCMemberSlice",
    initialState,
    reducers: {
      setLoadingState : (state, { payload }) => {
        state.loadingStatus = payload;
      },
      setSearchedParameter: (state, { payload }) => {
          state.searchedParameter = payload;
        },
      setMemberLists: (state, { payload }) => {
          state.memberList = payload;
        },
        clearMemberLists: (state,action) => {
          state.memberList = initialState.memberList;
        },
    },
     // extraReducers: {},
  });

export const {setLoadingState, setSearchedParameter,setMemberLists,clearMemberLists } = MemberSlice.actions;


export default MemberSlice.reducer;
